import jump from 'jump.js';

document.querySelectorAll('.js-scroll-to, [data-scroll="true"]').forEach(($el) => {
  $el.addEventListener('click', (event) => {
    // No href? No action
    if (!$el.getAttribute('href')) {
      return;
    }

    // Prevent default action
    event.preventDefault();

    // Add hash to history
    window.history.replaceState(false, false, $el.getAttribute('href'));

    // Jump to element
    jump($el.getAttribute('href'), {
      offset: -30,
      duration: 350,
    });
  });

  // Don't set focus state
  $el.addEventListener('mousedown', e => e.preventDefault());
});
